import 'react-native-gesture-handler';
import React from 'react';
import NotFoundScreen from '../screens/NotFoundScreen';
import LoginScreen from '../screens/LoginScreen';
import SignUpStack from '../screens/SignUpStack';
import ForgotStack from '../screens/ForgotStack';
import AcceptTermsScreen from '../screens/AcceptTermsScreen';
//import HomeTabs from '../screens/HomeTabs';
import MoreDrawer from '../screens/MoreDrawer';
import ProjectScreen from '../screens/Projects/Project/ProjectScreen'; // testing
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import NavOptions from '../constants/NavOptions';
// import { navigationRef } from '../utils/RootNavigation';
import UserState from './contexts/UserState';
import * as Linking from 'expo-linking';
import * as Notifications from 'expo-notifications';
import * as RootNavigation from '../utils/RootNavigation';
import { Storage } from '../components';

const Stack = createStackNavigator();

export default function RenovationTrustApp() {
  const [user, setUser] = React.useContext(UserState);
  const [notification, setNotification] = React.useState(false);
  const notificationListener = React.useRef();
  const responseListener = React.useRef();

  // deep links
  React.useEffect(() => {
    Linking.getInitialURL().then((url) => {
      console.log('useEffect getInitialURL url', url);
      // handleUrl(url);
    });
    // Linking.addEventListener('url', linkingListener);
    // return () => {
    //   // Clean up the event listeners
    //   Linking.removeEventListener('url', linkingListener);
    // };
  }, [user.isLoggedIn]);
  
  const linkingListener = (data) => {
    console.log('linkingListener', data);
    handleUrl(data.url);
  }
  const handleUrl = (url) => {
    console.log('handleUrl url: ', url);
    // return;
    if (!url) { return; }
    const { path, queryParams } = Linking.parse(url);
    const loggedOutScreens = ['create_password'];
    console.log('path', path);
    console.log('queryParams', queryParams);
    console.log('loggedOutScreens.includes(queryParams.screen)', loggedOutScreens.includes(queryParams.screen));
    console.log('user', user);
    console.log('user.isLoggedIn', user.isLoggedIn);
    // RootNavigation.navigate(path);
    return;
    
    // if(loggedOutScreens.includes(queryParams.screen) || user.isLoggedIn){
      console.log('isLoggedIn or is logged out screen');
      if (queryParams.screen) {
        console.log('is queryParams.screen');
        /**
        - Login
        - ForgotStack
          - ForgotPassword
          - CreatePassword
        - SignUp
          - EmailPassword
          - Terms
          - PersonalProfile
          - VerifyIdentity
          - CompanyProfile
          - Money
          - VerifyDetails
        - MoreDrawer (logged in)
          - MainTabs
            - MoneyStack
              - Money
              - Estimate
            - ProjectsStack
              - Projects
              - ProjectStack
                - Project
                - Invite1
                - Invite2
                - Invite3
            - Customers
            - Contractors
            - DisputesStack
              - Disputes
              - HowItWorks
              - DisputeQuestions
              - DisputePayment
          - PersonalProfile
          - CompanyProfile
          - FeeCalculator
          - HowItWorks (website link)
          - Resources
          - Help (chat)
          - Logout
        */
        try{
          switch (queryParams.screen) {
            case 'Login':
            case 'login':
              RootNavigation.navigate('Login')
              return;
            case 'home':
              RootNavigation.navigate('MoreDrawer', {
                screen: 'MainTabs',
                params: {
                  screen: 'HomeStack',
                  params: {
                    screen: 'Home',
                  }
                }
              });
              return;
            case 'money':
              // console.log('wtf money screen');
              RootNavigation.navigate('MoreDrawer', {
                screen: 'MainTabs',
                params: {
                  screen: 'MoneyStack',
                  params: {
                    screen: 'Money',
                  }
                }
              });
              return;
            case 'agreements':
              RootNavigation.navigate('MoreDrawer', {
                screen: 'MainTabs',
                params: {
                  screen: 'ProjectsStack',
                  params: {
                    screen: 'Projects',
                    initial: false,
                  }
                }
              });
              return;
            case 'agreement':
              console.log('case agreement: ', queryParams.id);
              if (queryParams.id) {
                RootNavigation.navigate('MoreDrawer', {
                  screen: 'MainTabs', 
                  params: {
                    screen: 'ProjectsStack',
                    params: {
                      screen: 'ProjectStack',
                      params: {
                        screen: 'Project',
                        // initial: false,
                        params: {
                          projectId: queryParams.id,
                          refresh: Date.now(),
                        }
                      }
                    }
                  }
                });
              }
              return;
            case 'contractors':
              RootNavigation.navigate('MoreDrawer', {
                screen: 'MainTabs',
                params: {
                  screen: 'Contractors',
                  initial: false,
                }
              });
              return;
            case 'customers':
              RootNavigation.navigate('MoreDrawer', {
                screen: 'MainTabs',
                params: {
                  screen: 'Customers',
                  initial: false,
                }
              });
              return;
            case 'profile':
              RootNavigation.navigate('PersonalProfile');
              return;
            case 'company_profile':
              RootNavigation.navigate('CompanyProfile');
              return;
            case 'disputes':
              RootNavigation.navigate('MoreDrawer', {
                screen: 'MainTabs',
                params: {
                  screen: 'DisputesStack',
                  params: {
                    screen: 'Disputes',
                  }
                }
              });
              return;
            case 'create_password':
              RootNavigation.navigate('Forgot', {
                screen: 'CreatePassword', 
                params: {
                  username: queryParams.username,
                  token: queryParams.token,
                }
              });
              return;
            default:
              return;
              // return RootNavigation.navigate('Home');
          }
        }catch(err) {
          console.log('handle url catch: ', err)
        }
      }
    // }
  }

  // notifications
  Notifications.setNotificationHandler({
    handleNotification: async () => ({
      shouldShowAlert: true,
      shouldPlaySound: false,
      shouldSetBadge: false,
    }),
  });
  React.useEffect(() => {
    // This listener is fired whenever a notification is received while the app is foregrounded
    // notificationListener.current = Notifications.addNotificationReceivedListener(notification => {
    //   console.log('addNotificationResponseReceivedListener 1', notification);
    //   setNotification(notification);
    // });

    // This listener is fired whenever a user taps on or interacts with a notification (works when app is foregrounded, backgrounded, or killed)
    // responseListener.current = Notifications.addNotificationResponseReceivedListener(response => {
    //   console.log('addNotificationResponseReceivedListener 2', response);
    //   handleUrl(response.notification.request.content.data.url);
    // });

    return () => {
      // Notifications.removeNotificationSubscription(notificationListener.current);
      // Notifications.removeNotificationSubscription(responseListener.current);
    };
  }, []);
  const prefix = Linking.createURL('/');
  console.log('Linking.createURL(/): ', prefix);
  const linking = {
    prefixes: [
      "https://*.renovationtrust.com",
      "https://renovationtrust.com",
      "https://*.*.renovationtrust.com",
      "renovationtrust://",
      prefix
    ],
    config: {
      screens: {
        Login: {
          path: 'login',
        },
        SignUp: {
          path: 'signup',
          initialRouteName: 'emailpassword',
          screens: {
            // EmailPassword //production
            // Terms
            // AccountType
            // VerifyBusiness
            // CompanyProfile
            // PersonalProfile
            // VerifyIdentity
            // EmergencyContacts
            // Money
            EmailPassword: {
              path: 'emailpassword',
            },
            Terms: {
              path: 'terms',
            },
            AccountType: {
              path: 'accounttype',
            },
            VerifyBusiness: {
              path: 'verifybusiness',
            },
            CompanyProfile: {
              path: 'companyprofile',
            },
            PersonalProfile: {
              path: 'personalprofile'
            },
            VerifyIdentity: {
              path: 'verifyidentity',
            },
            EmergencyContacts: {
              path: 'emergencycontacts',
            },
            Money: {
              path: 'money',
            },
          }
        },
        Forgot: {
          path: 'forgot',
          initialRouteName: 'ForgotPassword',
          screens: {
            ForgotPassword: {
              path: 'forgotpassword',
              exact: true,
            },
            CreatePassword: {
              path: 'createpassword/:username/:token',
              exact: true,
            }
          }
        },
        AcceptTermsScreen: {
          path: 'acceptterms',
          exact: true,
        },
        ProjectScreen: {
          path: 'invite/:projectId',
          exact: true,
        },
        MoreDrawer: {
          initialRouteName: 'Projects',
          // path: 'projects',
          screens: {
            MainTabs: {
              screens: {
                ProjectsStack: {
                  screens: {
                    Projects: {
                      path: 'projects',
                      exact: true,
                    },
                    CompletedProjects: {
                      path: 'completedprojects',
                      exact: true,
                    },
                    CreateProjectTutorial: {
                      path: 'projects/create_project_tutorial',
                      exact: true,
                    },
                    ProjectStack: {
                      screens: {
                        Project: {
                          path: 'project/:projectId',
                          exact: true,
                        },
                        InviteScreen: {
                          path: 'project/:projectId/invite',
                          exact: true,
                        },
                        InviteSuccess: {
                          path: 'project/:projectId/invite/success',
                          exact: true,
                        },
                        Milestone: {
                          path: 'project/:projectId/milestone/:milestoneId',
                          exact: true,
                        },
                        PaymentMethod: {
                          path: 'project/:projectId/milestone/:milestoneId/method/:acceptCreditCards',
                          exact: true,
                        },
                        Payment: {
                          path: 'project/:projectId/milestone/:milestoneId/payment/:paymentMethod',
                          exact: true,
                        },
                        ProjectTermsScreen: {
                          path: 'project/:projectId/terms',
                          exact: true,
                        },
                        ProjectChanges: {
                          path: 'project/:projectId/changes',
                          exact: true,
                        }
                      }
                    }
                  }
                },
                MoneyStack: {
                  screens: {
                    Money: {
                      path: 'money',
                      exact: true,
                    },
                    Estimate: {
                      path: 'estimate',
                      exact: true,
                    }
                  }
                },
                CustomersStack: {
                  screens: {
                    Customers: {
                      path: 'customers',
                      exact: true,
                    },
                    Customer: {
                      path: 'customer/:customerId',
                      exact: true,
                    },
                    InviteScreen: {
                      path: 'customer/:customerId/invite',
                      exact: true,
                    },
                    InviteSuccess: {
                      path: 'customer/:customerId/invite/success',
                      exact: true,
                    }
                  }
                },
                ContractorsStack: {
                  screens: {
                    Contractors: {
                      path: 'contractors',
                      exact: true,
                    },
                    Contractor: {
                      path: 'contractor/:contractorId',
                      exact: true,
                    },
                    InviteScreen: {
                      path: 'contractor/:contractorId/invite',
                      exact: true,
                    },
                    InviteSuccess: {
                      path: 'contractor/:contractorId/invite/success',
                      exact: true,
                    }
                  }
                },
                DisputesStack: {
                  screens: {
                    Disputes: {
                      path: 'disputes',
                      exact: true,
                    },
                    HowItWorks: {
                      path: 'howdisputeswork/:agreementId?',
                      exact: true,
                    },
                    DisputeInformation: {
                      path: 'dispute/:agreementId/information',
                      exact: true,
                    },
                    DisputeAction: {
                      path: 'dispute/:agreementId/action',
                      exact: true,
                    },
                    DisputeQuestions: {
                      path: 'dispute/:agreementId/questions',
                      exact: true,
                    },
                    DisputePayment: {
                      path: 'dispute/:agreementId/:freshDeskId/payment',
                      exact: true,
                    },
                    // Dispute: {
                    //   path: 'dispute/:disputeId',
                    //   exact: true,
                    // }
                  }
                }
              }
            },
            PersonalProfile: {
              path: 'profile',
              exact: true,
            },
            CompanyProfile: {
              path: 'companyprofile',
              exact: true,
            },
            FeeCalculator: {
              path: 'feecalculator',
              exact: true,
            }
          }
        },
        NotFoundScreen: '*',
      }
    },
    async getInitialURL() {
      // Check if app was opened from a deep link
      const url = await Linking.getInitialURL();
      console.log('getInitialURL: ', url);
      // alert(`url: ${url} - prefix: ${prefix}`);
      return handleUrl2(url);

      // Check if there is an initial firebase notification
      // const message = await messaging().getInitialNotification();

      // Get deep link from data
      // if this is undefined, the app will open the default/home page
      // return message?.data?.link;
    },
    subscribe(listener) {
      const onReceiveURL = ({ url }) => {
        console.log('onReceiveURL: ', url);
        if(user.isLoggedIn){
          listener(url); // works when logged in
        }else{
          return handleUrl2(url); // works when logged out
        }
      }

      // Listen to incoming links from deep linking
      const sub = Linking.addEventListener('url', onReceiveURL);

      // Listen to expo push notifications
      const subscription = Notifications.addNotificationResponseReceivedListener(response => {
        const url = response.notification.request.content.data.url;
        const isLoggedInPath = url.search(/login|forgot|signup/g) === -1 ? true : false;
        
        console.log('url: ', url, user.isLoggedIn, isLoggedInPath);
        // Any custom logic to see whether the URL needs to be handled
        //...

        // Let React Navigation handle the URL
        // listener(`${prefix}${url}`);
        if(user.isLoggedIn){
          if(isLoggedInPath){
            listener(`${prefix}${url}`);
          }
        }else{
          if(!isLoggedInPath){
            listener(`${prefix}${url}`);
          }else{
            // not logged in trying to go to logged in path
            console.log('handle url once logged in:', url);
            Storage.setItem('deepLink', url);
          }
        }
        
        
        // RootNavigation.navigate(url);
        // handleUrl(url);
        // Linking.openURL(url);
        // linkTo(`/${url}`);
        // RootNavigation.linkTo(url);
      });

      return () => {
        // Clean up the event listeners
        // Linking.removeEventListener('url', onReceiveURL);
        sub.remove();
        subscription.remove();
      };
    },
  }
  const handleUrl2 = (url) => {
    if(!url){ return undefined; }
    const isLoggedInPath = url.search(/login|forgot|signup|invite/g) === -1 ? true : false;
    // const isProjectPath = url.search(/project/g) === -1 ? true : false;
    // if (isProjectPath && !user.isLoggedIn){
    //   console.log('project path and not logged in');
    //   url += '/invite';
    // }
    const { path } = Linking.parse(url);
    console.log('handleUrl2: ', url, user.isLoggedIn, isLoggedInPath, Linking.parse(url));

    // if (url != null) {
    //   return url;
    // }
    if (!path) { return undefined; }
    if (user.isLoggedIn) {
      if (isLoggedInPath) {
        return url;
        Storage.setItem('deepLink', path);
        return undefined;
      }
    } else {
      if (!isLoggedInPath) {
        return url;
      } else {
        // not logged in trying to go to logged in path
        console.log('handle initial url once logged in:', path);
        if(path !== '@renovationtrust/RenovationTrust'){
          Storage.setItem('deepLink', path);
        }
        return undefined;
      }
    }
  }

  return (
    // initialRouteName='Login'
    <NavigationContainer
      ref={RootNavigation.navigationRef}
      linking={linking}
      // onStateChange={(state) => { console.log('onStateChange', state)}}
    >
      <Stack.Navigator screenOptions={NavOptions.all}>
        {!user.isLoggedIn ? (
          <>
            <Stack.Screen
              name='Login'
              options={NavOptions.login}
              component={LoginScreen}
            />
            <Stack.Screen
              name='Forgot'
              component={ForgotStack}
            />
            <Stack.Screen
              name='SignUp'
              // initialParams={{ }}
              component={SignUpStack}
            />
            <Stack.Screen
              name='AcceptTermsScreen'
              component={AcceptTermsScreen}
            />
            <Stack.Screen
              name='ProjectScreen'
              component={ProjectScreen}
            />
          </>
        ) : (
            <Stack.Screen
              name='MoreDrawer'
              options={NavOptions.home}
              component={MoreDrawer}
            />
        )}
        <Stack.Screen
          name='NotFoundScreen'
          options={{ headerShown: true, headerTitle: null}}
          component={NotFoundScreen}
        />
      </Stack.Navigator>
    </NavigationContainer>
  )

}
